import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export type ListUserCaseAndCountOutput = {
  data: listAllCaseAdministrativeOutput[];
  total: number;
}

export type contactInput = {
  id?: number;
  contactMethod: string;
  contact: string;
  primaryContact?: boolean;
};

export type listAllCaseAdministrativeOutput = {
  id: number;
  name: string;
  contact: string;
  ownerName: string;
  ownerEmail: string;
  createdAt: number;
  createdAtString?: string;
}

export type caseInformationOutput = Omit<createCase, 'casePatient'> & {
  casePatientId: PatientInfo;
};

export type caseInformationInput = createCase;

export type deleteContactInput = {
  caseId: number;
  contactId: number[];
}

export type createCase = {
  id?: number;
  benefitType: string;
  benefitDescription: string;
  inssStatus: string;
  hasMedicalDocument?: boolean;
  documentHasCid?: boolean;
  isBpc?: boolean;
  isCadUnico?: boolean;
  periodRequirement?: boolean;
  observation: string;
  casePatient: PatientInfo;
};

export type PatientInfo = {
  name: string;
  document: string;
  state?: string;
  city?: string;
  contacts: PatientContact[];
};

export type PatientContact = {
  id?: number;
  contactMethod: string;
  contact: string;
  primaryContact: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class CasesAdminService {
  private apiUrl = `${environment.api_v2}/v2/administrative/cases`;

  constructor(private http: HttpClient){}
  updateCaseActiveStatus(caseId: number): Observable<{message: string, status: number}>{
    return this.http.put<{message: string, status: number}>(`${this.apiUrl}/${caseId}/change-status`, null);
  }

  deleteContact(input: deleteContactInput) {
    return this.http.delete(this.apiUrl, {  body: input });
  }

  updateCase(id: number, body: caseInformationInput): Observable<{message: string, status: number, data: null}> {
    return this.http.put<{message: string, status: number, data: null}>(`${this.apiUrl}/${id}`, body);
  }

  findById(id: number): Observable<caseInformationOutput> {
    return this.http.get<caseInformationOutput>(`${this.apiUrl}/${id}`);
  }

  findAllCases(filter: string, pagination: {page: number, perPage: number}): Observable<ListUserCaseAndCountOutput> {
    const params = new HttpParams()
      .set('filter', filter)
      .set('page', pagination.page)
      .set('perPage', pagination.perPage);
    
    return this.http.get<ListUserCaseAndCountOutput>(this.apiUrl, {params});
  }

  createCase(form: createCase): Observable<{message: string, status: number, data: null}> {
    return this.http.post<{message: string, status: number, data: null}>(this.apiUrl, form);
  }
}
